import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { VisionButtonModule } from '../vision-button/vision-button.module';
import { AnchorButtonComponent } from './anchor-button/anchor-button.component';

@NgModule({
  exports: [AnchorButtonComponent],
  imports: [CommonModule, FontAwesomeModule, QueryParamModule, VisionButtonModule, AnchorButtonComponent],
})
export class AnchorButtonModule {}
